<template>
  <div class="create-promotion">
    <SidebarLayout2
      :breadcrumb="breadcrumb"
      pageTitle="Configuração de diferenciais"
    >
      <!-- SIDEBAR -->
      <template v-slot:sidebar>
        <InfoPanel height="155" class="info-panel">
          <template v-slot:content>
            <!-- NOME DO HOTEL -->
            <Heading v-if="hotel" class="info-panel--title heading--size-2">
              {{ hotel.nome }}
            </Heading>
          </template>
        </InfoPanel>

        <SidebarBlock class="pmw-page-actions">
          <!-- MENU DE HOTEIS -->
          <PmwHotelNav
            :links="menuLinks"
            :hide="['banners']"
            active="diferenciais"
            class="menu-nav"
          />

          <Heading element="h2" class="pmw-sidebar-title">
            Ações da página
          </Heading>

          <!-- BOTÃO SALVAR SÓ FICA ATIVADO QUANDO O NOME FOR PREENCHIDO -->
          <PmwButton
            :tooltipMinWidth="200"
            popperStrategy="auto"
            variation="pmw-primary"
            tooltipText="Preencha os itens com o *(asterisco) que indicam os campos obrigatórios para salvar."
            class="pmw-page-actions--button"
            @click="saveDifferentials()"
          >
            Salvar
          </PmwButton>

          <!-- BOTÃO RETORNAR -->
          <PmwButton
            variation="blue-100"
            layout="outline"
            class="pmw-page-actions--button"
            @click="toHotels()"
          >
            Voltar sem salvar
          </PmwButton>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template v-slot:content>
        <!-- TITULO DE ACOMODAÇÃO -->
        <PmwTitleWithLine
          title="Tipo de acomodação"
          description="Configure o diferencial no valor e restrições de acordo com o tipo de acomodação."
        />

        <AccommodationTable
          :rooms="rooms"
          :roomsDiscountOptions="roomsDiscountOptions"
          :roomsTypeOptions="valueTypeOptions"
          :sendData="returnDataFromChild"
          class="table"
          @input="accommodationData"
        />

        <!-- TITULO DE PAX -->
        <PmwTitleWithLine
          title="Tipo de pax"
          description="Configure acréscimos ao valor da tarifa de acordo com a quantidade de adultos e crianças na acomodação."
        />

        <PaxTable
          :paxes="paxes"
          :paxTypeOptions="valueTypeOptions"
          :sendData="returnDataFromChild"
          class="table"
          @input="paxData"
        />

        <SeparateLine :left="0" :right="0" :top="64" :bottom="56" />

        <!-- BOTÕES NO RODAPÉ DA PÁGINA -->
        <span class="pmw-bottom-action">
          <PmwButton
            variation="blue-100"
            layout="outline"
            class="pmw-bottom-action--button"
            @click="toHotels()"
          >
            Voltar sem salvar
          </PmwButton>

          <!-- BOTÃO SALVAR SÓ FICA ATIVO QUANDO O NOME FOR PREENCHIDO -->
          <PmwButton
            popperStrategy="absolute"
            variation="pmw-primary"
            tooltipText="Preencha os itens com o *(asterisco) que indicam os campos obrigatórios para salvar."
            class="pmw-bottom-action--button"
            @click="saveDifferentials()"
          >
            Salvar
          </PmwButton>
        </span>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
/** Componentes */

/** Locais */
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import hotelCommonsMixin from '@/mixins/hotelCommonsMixin'
import AccommodationTable from '@/components/hotel/differentials/AccommodationTable.vue'
import PaxTable from '@/components/hotel/differentials/PaxTable.vue'
import { capitalizeString } from '@/helpers/string'

/** Biblioteca */
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import InfoPanel from '@solucoes/components-lib-tmp/src/components/patterns/InfoPanel'
import PmwTitleWithLine from '@solucoes/components-lib-tmp/src/components/elements/PmwTitleWithLine'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'

export default {
  name: 'Differentials',
  mixins: [hotelCommonsMixin],
  components: {
    PmwButton,
    Heading,
    SidebarLayout2,
    SidebarBlock,
    InfoPanel,
    PmwTitleWithLine,
    SeparateLine,
    AccommodationTable,
    PaxTable
  },
  data() {
    return {
      returnDataFromChild: false,
      /** Caminho de pão */
      breadcrumb: [],

      /** Informações do hotel */
      hotel: null,

      /** Tipos pax cadastrado */
      paxes: null,

      /** Quartos cadastrados */
      rooms: null,

      /** Opções de seleção dos select de desconto */
      roomsDiscountOptions: [],

      /** Opções de seleção dos select de tipo de valor */
      valueTypeOptions: [],

      /** Valor temporario dos inputs */
      inputs: null,

      /** Paxes retornados da tabela */
      returnedPax: null,

      /** Quartos retornados da tabela */
      returnedRooms: null
    }
  },

  async created() {
    /** Retorno de dados do hotel */
    await this.$hotel.get(this.$route.params.id).then((response) => {
      this.hotel = response.data

      /** Define o valor do breadcrumb */
      this.breadcrumb = [
        {
          label: 'Letsbook'
        },
        {
          label: 'Hotéis',
          url: '/hoteis',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: capitalizeString(this.hotel.nome),
          url: `/hoteis/editar/${this.hotel.codigo}`,
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: 'Configuração de Diferenciais',
          url: '/',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        }
      ]
    })

    /** Realiza novamente a chamada dos dados */
    this.getDifferentials()
  },
  methods: {
    /** Salva a configuração do diferencial */
    async saveDifferentials() {
      /** Manda a props de retorno de dados da tabela */
      await this.returnData()

      /** Chama a função de ajuste dados de pax */
      this.filterPaxes()

      /** Chama a função de ajuste dados de acomodação */
      this.filterRooms()

      /** Chamada da API para salvar diferencial */
      this.$differentials
        .createConfig({
          codigoHotel: parseInt(this.$route.params.id),
          quartos: this.returnedRooms,
          pax: this.returnedPax
        })
        .then(() => {
          /** Mostra a mensage se sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Configuração de diferenciais salva com sucesso.'
          })

          /** Realiza novamente a chamada dos dados */
          this.getDifferentials()
        })

        .catch((err) => {
          this.$bus.$emit('show-alert-chip', {
            message: err.messages[0]
          })
        })
    },

    /** Retorna dados da tabela de tipo de acomodação
     * @param {Array} returnedRooms Valores de quartos editados na tabela
     */
    accommodationData(returnedRooms) {
      this.returnedRooms = returnedRooms
    },

    /** Ajusta dados de acomodação para salvar */
    filterRooms() {
      this.returnedRooms.forEach((item) => {
        item.tipoValor = item.tableTipoValor.value
        item.tipoDiferencial = item.tableTipoDiferencial.value
        item.valor === null ? (item.valor = 0) : item.valor
        item.valor === '' ? (item.valor = 0) : item.valor
      })
    },

    /** Retorna dados da tabela de tipo de pax
     * @param {Array} returnedPaxes Valores de Paxes editados na tabela
     */
    paxData(returnedPaxes) {
      this.returnedPax = returnedPaxes
    },

    /** Ajusta dados de pax para salvar */
    filterPaxes() {
      this.returnedPax.forEach((item) => {
        const filtered = item.ocupantes.filter((filterItem) => {
          item.ocupantes.forEach((subitem) => {
            /** Adiciona o tipo de valor para cada ocupante */
            if (subitem.quantidadeOcupantes !== 0) {
              subitem.tipoValor = item.tipoValor.value
            }

            /** Adiciona o valor de 0 nos itens que estiverem como null e com a quantidade permitida pelo hotel */
            if (subitem.quantidadeOcupantes <= item.maximoOcupantesAdicionais) {
              subitem.valor === null ? (subitem.valor = 0) : subitem.valor
              subitem.valor === '' ? (subitem.valor = 0) : subitem.valor
            }
          })

          /** Retorna apenas os itens com a quantidade permitida pelo hotel */
          return filterItem.quantidadeOcupantes > item.maximoOcupantesAdicionais
            ? (filterItem = null)
            : filterItem.quantidadeOcupantes
        })

        /** Adiciona ao Array os itens já padronizados */
        item.ocupantes = filtered
      })
    },

    /** Retorna dados de diferenciais de Acomodação e Pax */
    getDifferentials() {
      this.$differentials.get(this.$route.params.id).then((response) => {
        const results = response.data

        /** Adiciona itens para ser mostrado no componente */
        results.quartos.map((item) => {
          item.tableTipoDiferencial = null
          item.tableTipoValor = null
        })

        /** Verifica se os itens são vazios para adicionar as opções padrões */
        results.quartos.forEach((item) => {
          /** Define o valor do tipo de diferencial */
          if (item.tipoDiferencial === null || item.tipoDiferencial === 1) {
            item.tableTipoDiferencial = {
              text: 'Acréscimo',
              value: 1
            }
          } else {
            item.tableTipoDiferencial = {
              text: 'Desconto',
              value: 2
            }
          }

          /** Define o valor do tipo de valor */
          if (item.tipoValor === null || item.tipoValor === 2) {
            item.tableTipoValor = {
              text: 'Absoluto',
              value: 2
            }
          } else {
            item.tableTipoValor = {
              text: 'Percentual',
              value: 1
            }
          }
        })

        this.rooms = results.quartos

        /** Envia o valor padrão de tipo de valor do Pax */
        results.pax.map((item) => {
          item.tableOcupantes = item.ocupantes
          item.tipoValor = null
        })

        /** Opções de tipo de valor de acomodação e pax */
        this.valueTypeOptions = [
          {
            text: 'Percentual',
            value: 1
          },
          {
            text: 'Absoluto',
            value: 2
          }
        ]

        /** Opções de tipo de desconto de acomodação */
        this.roomsDiscountOptions = [
          {
            text: 'Acréscimo',
            value: 1
          },
          {
            text: 'Desconto',
            value: 2
          }
        ]

        /** Realiza tratamento dos dados do pax para envio ao componente */
        results.pax.forEach((item) => {
          /** Atribui o valor do select de acordo com o tipo de valor do pax */
          if (item.ocupantes.length > 0) {
            item.ocupantes.forEach((subitem) => {
              if (
                subitem.tipoValor === null ||
                subitem.tipoValor === 0 ||
                subitem.tipoValor === 1
              ) {
                item.tipoValor = {
                  text: 'Percentual',
                  value: 1
                }
              } else {
                item.tipoValor = {
                  text: 'Absoluto',
                  value: 2
                }
              }
            })
          } else {
            item.tipoValor = {
              text: 'Percentual',
              value: 1
            }
          }

          /** Adicionar itens ao array para sempre ter cinco itens cadastrados */
          for (let i = item.tableOcupantes.length + 1; i <= 5; i++) {
            const obj = {
              tipoValor: 1,
              valor: null
            }

            /** Define o valor do item de Quantidade de Ocupantes no pax */
            obj['quantidadeOcupantes'] = i

            item.tableOcupantes.push(obj)
          }

          /** Ordenação dos itens basedado na Quantidade de Ocupantes */
          const byOrder = item.tableOcupantes.slice(0)
          byOrder.sort(function(a, b) {
            return a.quantidadeOcupantes - b.quantidadeOcupantes
          })

          item.tableOcupantes = byOrder
        })

        this.paxes = results.pax
      })
    },
    /** Manda a props para retorno de dados das tabelas */
    returnData() {
      this.returnDataFromChild = !this.returnDataFromChild
    },
    /** Redirecionar para a tela de hotéis */
    toHotels() {
      this.$router.push({
        path: '/hoteis'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  margin-top: 28px;
}

.pmw-sidebar {
  &-title {
    margin-bottom: 20px;
  }

  &-buttons {
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}
.menu-nav {
  max-height: calc(100vh - 395px);
  overflow-y: scroll;
}
.pmw-name-input {
  width: 441px;
  display: flex;
  float: left;
  margin-right: 50px;
  flex-direction: column;
  .character-count {
    margin-left: auto;
    padding-top: 7px;
    color: $gray-dark;
  }
}
.pmw-description-input {
  width: 441px;
  display: flex;
  flex-direction: column;
  .character-count {
    margin-left: auto;
    padding-top: 7px;
    color: $gray-dark;
  }
}

.pmw-bottom-action {
  display: flex;
  justify-content: space-between;
  &--button {
    width: 180px;
  }
}
.tab-title {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pmw-page-actions {
  padding-top: 50px;
  &--button {
    width: 100%;
    cursor: pointer;

    & + .pmw-page-actions--button {
      margin: 10px 0;
    }
  }
}

::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}

::v-deep .content {
  /** Padding abaixo do título da página */
  .page-heading {
    padding-bottom: 24px;
  }
}
</style>
